import type { ReactNode } from "react";
import { gaps } from "../../spacing";
import { SectionTitle } from "../../data-display/SectionTitle";
import { Subtitle } from "../../data-display/Subtitle";
import { CenteredStack } from "../../layout/CenteredStack";

interface EmptyStateProps {
  title?: ReactNode;
  message: ReactNode;
  /** Optional action slot, e.g. a "Start over" button. */
  action?: ReactNode;
  minHeight?: number | string;
}

/** Centered title/message with an optional action, for empty / not-found page states. */
export function EmptyState({ title, message, action, minHeight = 240 }: EmptyStateProps) {
  return (
    <CenteredStack gap={gaps.base} $minHeight={minHeight} $textAlign="center">
      {title ? <SectionTitle>{title}</SectionTitle> : null}
      <Subtitle>{message}</Subtitle>
      {action}
    </CenteredStack>
  );
}
